import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import ItemInjector from "@mnjsplatform/components/lib/common/ItemInjector";

export default (props) => {
    return <ItemInjector key={`CreateClaim_${props.rowKey.TypeClaimViewIntId}`}
                         dataItem={{
                             controller: "Claim",
                             methodName: props.settings["MethodCreateForPO"],
                             withParamset: true,
                             fieldName: props.rowKey.TypeClaimViewIntId
                         }}>
        <ConnectedCreateClaim {...props} />
    </ItemInjector>
}

class CreateClaim extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem.initialize(this.props.rowKey, {
                newItem: true,
                withParams: true,
                refresh: false
            }));
        } catch (e) {
            console.error(e);
        }
    };

    save = async () => {
        await this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItemParams));
        if (!this.props.dataItem.isError) {
            this.props.onCreated(this.props.dataItem.getRow(0));
            this.props.onClose();
        }
    }

    renderButtons = () => {
        return (
            <div className="modal-footer text-right">
                <button type="button" className="btn btn-regular -goahead"
                        onClick={this.save}>{i18next.t("CreateStatement")}</button>
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={this.props.onClose}>{i18next.t("Cancel_Noun")}</button>
            </div>
        );
    };

    render() {
        return (
            <PopupWrapper popupVisible={true} title={i18next.t("Request_Creation")}
                          onClose={this.props.onClose} renderButtons={this.renderButtons} instructionId="12">
                <ComplexParam dataItem={this.props.dataItemParams}
                              showApplyButton={false} showSearchBar={false}
                              renderParams={paramRender}
                />
            </PopupWrapper>
        );
    }
}

CreateClaim.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItemParams: PropTypes.object,
    onCreated: PropTypes.func,
    onClose: PropTypes.func,
    rowKey: PropTypes.object
};

CreateClaim.defaultProps = {
    onCreated: () => {},
    onClose: () => {}
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: ownProps.getItemState(state),
        dataItemParams: ownProps.getItemStateParams(state),
    }
}

const ConnectedCreateClaim = connect(mapStateToProps)(CreateClaim);